import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PAGE_SIZE } from '../../models/period-trends.const';

// Pagination strip used by every tab's tables. Removes 8x copies
// of the same prev/numbered/next button block from the markup.
@Component({
  selector: 'tangram-analytics-pagination',
  templateUrl: './analytics-pagination.component.html',
  styleUrls: ['./analytics-pagination.component.scss']
})
export class AnalyticsPaginationComponent {
  @Input() page = 1;
  @Input() total = 0;
  @Input() pageSize = PAGE_SIZE;
  @Output() pageChange = new EventEmitter<number>();

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.total / this.pageSize));
  }

  get pages(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  get rangeStart(): number {
    return this.total === 0 ? 0 : (this.page - 1) * this.pageSize + 1;
  }

  get rangeEnd(): number {
    return Math.min(this.page * this.pageSize, this.total);
  }

  setPage(p: number): void {
    if (p < 1 || p > this.totalPages || p === this.page) { return; }
    this.pageChange.emit(p);
  }
}
